<div class="row">
    <ng-container *ngFor="let e of showElements">
        <div *ngIf="e.value" [ngClass]="{'hide-print': e?.imprimir === false}" class="col-lg-{{cols}} col-md-4 p-2">
            <div class="text-secondary f-12">{{e.label}}</div>
            <div class="">
                <img *ngIf="templateValidoImg == true && (e.value == 'OK' || e.value == 'Original')" [src]="imagePathOk" alt="Status ok" loading="lazy">
                <img *ngIf="templateValidoImg == true && (e.value != 'OK' && e.value != 'Original' )" [src]="imagePathWarn" alt="Status de alerta" loading="lazy">

                {{e.value}}</div>
        </div>
    </ng-container>
</div>
